<script lang="ts">
	import type { WidgetState } from '../lib/widget.svelte';
	import { drawComposite, downloadCanvas } from '../lib/compositor';

	let { widget }: { widget: WidgetState } = $props();

	let canvasEl: HTMLCanvasElement | null = $state(null);

	const MOVE_STEP = 20;

	// Redibuja el composite ante cualquier cambio de plantilla/selfie/transformación
	$effect(() => {
		const config = widget.selectedTemplate?.config;
		const selfie = widget.selfieCanvas;
		const transform = widget.transform;

		if (canvasEl && config) {
			drawComposite(canvasEl, config, selfie, transform);
		}
	});

	// Flechas del teclado para trasladar la selfie
	function handleKeydown(event: KeyboardEvent) {
		const moves: Record<string, [number, number]> = {
			ArrowUp: [0, -MOVE_STEP],
			ArrowDown: [0, MOVE_STEP],
			ArrowLeft: [-MOVE_STEP, 0],
			ArrowRight: [MOVE_STEP, 0]
		};
		const move = moves[event.key];
		if (move) {
			event.preventDefault();
			widget.move(move[0], move[1]);
		}
	}

	function download() {
		if (!canvasEl) return;
		downloadCanvas(canvasEl, `${widget.data?.campaign?.name ?? 'selfie-studio'}.png`);
	}
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div class="ss-editor" onkeydown={handleKeydown} tabindex="0" role="application" aria-label="Editor de selfie">
	<div class="ss-canvas-wrap">
		<canvas bind:this={canvasEl}></canvas>
	</div>

	<div class="ss-controls">
		<!-- Traslación (también funciona con las flechas del teclado) -->
		<div class="ss-control-row">
			<label for="ss-dpad">Mover</label>
			<div class="ss-dpad" id="ss-dpad">
				<span></span>
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.move(0, -MOVE_STEP)} aria-label="Subir">↑</button>
				<span></span>
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.move(-MOVE_STEP, 0)} aria-label="Izquierda">←</button>
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.move(0, MOVE_STEP)} aria-label="Bajar">↓</button>
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.move(MOVE_STEP, 0)} aria-label="Derecha">→</button>
			</div>
			<div style="display:flex; gap:4px;">
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.zoom(1.1)} aria-label="Acercar">＋</button>
				<button type="button" class="ss-btn ss-btn-icon" onclick={() => widget.zoom(0.9)} aria-label="Alejar">－</button>
			</div>
		</div>

		<!-- Rotación -->
		<div class="ss-control-row">
			<label for="ss-rotation">Rotación</label>
			<input
				id="ss-rotation"
				type="range"
				min="-180"
				max="180"
				step="1"
				value={widget.transform.rotation}
				oninput={(e) => widget.rotate(Number(e.currentTarget.value))}
			/>
			<span style="font-size:11px; color:var(--ss-muted); width:38px; text-align:right;">
				{widget.transform.rotation}°
			</span>
		</div>
	</div>

	<div class="ss-actions">
		<button type="button" class="ss-btn" onclick={() => widget.retake()}>↺ Otra foto</button>
		<button type="button" class="ss-btn" onclick={() => widget.resetTransform()}>Centrar</button>
		<button type="button" class="ss-btn ss-btn-primary" onclick={download}>⬇ Descargar</button>
	</div>
</div>
